import React, { useState, useCallback, useMemo } from "react";
import { FileUploader } from "devextreme-react";
import { useDropzone } from "react-dropzone";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  actionEmpList,
  resetEmpList,
  actionEmpStatus,
  resetEmpStatus,
} from "../store";
import "devextreme/dist/css/dx.light.css";
import { RequiredRule, EmailRule, CustomRule } from "devextreme-react/form";
import DataGrid, {
  Export,
  Button,
  Column,
  FilterRow,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import "devextreme-react/text-area";
import moment from "moment";
import { getLocalStorageItem, onExporting } from "../../../../../utils";
import Swal from "sweetalert2";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
  TOAST_SUCCESS_COLOR,
} from "../../../../../common/app_constant";
import toast from "react-hot-toast";
import BulkUpload from "../../../../../component/bulk_upload";
import EmployeeAddEdit from "../../../../../component/popups/employee_add_edit";
import { useNavigate } from "react-router-dom";
import Loader from '../../../../../component/page_loader';
import { SUB_DIRECTORY } from "../../../../../common/constant";

const EmployeeList = () => {
  const navigate = useNavigate();
  const [viewEmpList, setViewEmpList] = useState();
  const [active, setActive] = useState(true);
  const [activeStatus, setActiveStatus] = useState('ACTIVE');

  const [viewEmpListCount, setViewEmpListCount] = useState(0);

  const [uploadBulk, setUploadBulk] = useState(false);
  const [role, setRole] = useState();
  const [isEmployeeModal, setIsEmployeeModal] = useState(false);
  const [employeeData, setEmployeeData] = useState();
  const [isLoader, setIsLoader] = useState(true);
  const dispatch = useDispatch();

  const { EmpStatus, EmpList } = useSelector(state => ({
    ...state.listStore,
  }));

  function formatStatus(status) {
  return status
    .toLowerCase()
    .split("_")
    .map((word, index) => 
      index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word
    )
    .join("-"); 
}
  useEffect(() => {
    setRole(getLocalStorageItem("next"));
    console.log("rere", getLocalStorageItem("next"))

    dispatch(
      actionEmpList({
        status: 'ACTIVE',
      })
    );
  }, []);

  useEffect(() => {
    const hasReloadedEmployees = localStorage.getItem("hasReloadedEmployees");
    if (!hasReloadedEmployees) {
      localStorage.setItem("hasReloadedEmployees", true);
      window.location.reload();
    }
  }, []);

  useEffect(() => {
    dispatch(resetEmpList());
    if (EmpList != null) {
      if (EmpList.status == true) {
        setIsLoader(false);
        setViewEmpList(EmpList.data.rows);
        setViewEmpListCount(EmpList.data.rows.length);
      } else {
        setIsLoader(false);
        switch (EmpList.status_code) {
          case 400:
            dispatch(resetEmpList());
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [EmpList]);

  useEffect(() => {
    if (EmpStatus) {
      dispatch(resetEmpStatus());
      if (EmpStatus.status === true) {
        // setActive(true);
        setActiveStatus('ACTIVE')
        dispatch(actionEmpList({ status: 'ACTIVE' }));
      } else {
        switch (EmpStatus.status_code) {
          case 400:
            dispatch(resetEmpStatus());
            toast.error(EmpStatus.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [EmpStatus]);

  const renderDateCell = date => {
    const formattedDate = moment(date).isValid()
      ? moment(date).format("DD-MMM-YYYY")
      : "-";
    return formattedDate;
  };

  const renderEmpStatus = data => (
    <button
      className={`btn btn-sm btn-${data.status === 'ACTIVE' ? "success" : "danger"} cursor-pointer w-100`}
      onClick={() =>{
        if(data.status !== "ON-HOLD"){
            Swal.fire({
              title: "",
              icon: "warning",
              text: `Are you sure you want to ${data.status === 'ACTIVE'? "Inactive" : "Active"
                }  '${data.full_name}'?`,
              showCancelButton: true,
              showConfirmButton: true,
              confirmButtonText: "Yes",
              cancelButtonText: "No",
              customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-danger ms-1 margin-left",
              },
            }).then(
              result =>
                result.value &&
                // dispatch(actionEmpStatus({ id: data?.id, status: !data.status }))
                dispatch(actionEmpStatus({ id: data?.id, status: data.status === 'ACTIVE'? "INACTIVE" : "ACTIVE" }))
            )
         }
        }
      }
    >
      {/* {data.status === 'ACTIVE' ? "Active" : "Inactive"} */}
      {formatStatus(data.status)}
    </button>
  );

  const rendercapitalizeData = value => {
    const captitalize = value
      ? value.charAt(0).toUpperCase() + value.slice(1)
      : "-";
    return captitalize;
  };

  const renderAction = data => (
    <button
      className={`btn btn-sm btn-primary cursor-pointer w-80`}
      onClick={() => {
        setIsEmployeeModal(true);
        setEmployeeData(data);
      }}
    >
      Edit
    </button>
  );

  return (
    <>
      <div className="row  justify-content-center mb-5 mt-6">
        <div className="col-12 mb-5">
          <div className="d-flex justify-content-between mb-2">
            <h5 className="mb-0">Employee List</h5>
            {activeStatus !== 'ON-HOLD' &&
            <div>
              {role == "copsdashboard" && (
                <button
                  className={`btn btn-sm btn-primary cursor-pointer`}
                  onClick={() => {
                    setUploadBulk(true);
                  }}
                >
                  Add Bulk
                </button>
              )}
            </div>
          }
          </div>
          {isLoader === true ? (
            <Loader />
          ) : (
            <div className="card border mt-3 d-flex">

              {/* old code */}
              {/* <div className="card-header">
                
                <button
                  className={`btn btn-sm me-2 ${active ? "btn-primary" : "btn-outline-secondary"
                    } cursor-pointer`}
                  onClick={() => {
                    setActive(true);
                    setViewEmpListCount(0);
                    dispatch(
                      actionEmpList({
                        status: 'ACTIVE',
                      })
                    );
                  }}
                >
                  {`Active ${active ? `(${viewEmpListCount})` : ''}`}
                </button>

                <button
                  className={`btn btn-sm ${!active ? "btn-primary" : "btn-outline-secondary"
                    } cursor-pointer `}
                  onClick={() => {
                    setActive(false);
                    setViewEmpListCount(0);
                    dispatch(
                      actionEmpList({
                        status: 'INACTIVE',
                      })
                    );
                  }}
                >
                  {`Inactive ${!active ? `(${viewEmpListCount})` : ''}`}
                </button>
                
              </div> */}


              {/* new code */}
              <div className="card-header">
                {/* Active button */}
                <button
                  className={`btn btn-sm me-2 ${activeStatus === "ACTIVE" ? "btn-primary" : "btn-outline-secondary"} cursor-pointer`}
                  onClick={() => {
                    setActiveStatus("ACTIVE");
                    setViewEmpListCount(0);
                    dispatch(actionEmpList({ status: "ACTIVE" }));
                  }}
                >
                  {`Active ${activeStatus === "ACTIVE" ? `(${viewEmpListCount})` : ""}`}
                </button>

                {/* Inactive button */}
                <button
                  className={`btn btn-sm me-2 ${activeStatus === "INACTIVE" ? "btn-primary" : "btn-outline-secondary"} cursor-pointer`}
                  onClick={() => {
                    setActiveStatus("INACTIVE");
                    setViewEmpListCount(0);
                    dispatch(actionEmpList({ status: "INACTIVE" }));
                  }}
                >
                  {`Inactive ${activeStatus === "INACTIVE" ? `(${viewEmpListCount})` : ""}`}
                </button>

                {/* On Hold button */}
                <button
                  className={`btn btn-sm ${activeStatus === "ON-HOLD" ? "btn-primary" : "btn-outline-secondary"} cursor-pointer`}
                  onClick={() => {
                    setActiveStatus("ON-HOLD");
                    setViewEmpListCount(0);
                    dispatch(actionEmpList({ status: "ON-HOLD" }));
                  }}
                >
                  {`On-Hold ${activeStatus === "ON-HOLD" ? `(${viewEmpListCount})` : ""}`}
                </button>
              </div>

              <div className="card-body" id="data-grid-demo">
                <DataGrid
                  id="emp_list"
                  dataSource={viewEmpList}
                  showBorders={true}
                  columnMinWidth={100}
                  filterSyncEnabled={false}
                  allowColumnResizing={true}
                  columnAutoWidth={true}
                  onExporting={onExporting}
                >
                  <SearchPanel visible={true} />
                  <FilterRow visible={true} />
                  <HeaderFilter visible={true} />
                  {(role == "copsdashboard" || role =="superuserdashboard" || role =="employerdashboard") && (
                    <Column
                      width={50}
                      dataField="action"
                      cellRender={({ data }) => renderAction(data)}
                      caption="Action"
                    ></Column>
                  )}
                  <Column
                    dataField="index"
                    caption="S.No"
                    dataType="number"
                    cellRender={rowData => {
                      return rowData?.rowIndex != null
                        ? Number(rowData?.rowIndex + 1)
                        : "-";
                    }}
                  />
                  <Column
                    dataField="full_name"
                    caption="Full Name "
                    cellRender={({ value }) => rendercapitalizeData(value)}
                  />
                  <Column
                    dataField="mobile"
                    caption="Mobile Number"
                    dataType="string"
                  />
                  <Column dataField="email" caption="Email ID " />
                  <Column
                    dataField="userCity.name"
                    caption="City "
                  />
                  <Column
                    dataField="userCity.cityState.stateZone.name"
                    caption="Zone "
                  />
                  <Column
                    dataField="created_at"
                    caption="Created at"
                    dataType="date"
                    cellRender={({ value }) => renderDateCell(value)}
                  />
                  <Column
                    dataField="updated_at"
                    caption="Updated at"
                    dataType="date"
                    cellRender={({ value }) => renderDateCell(value)}
                  />
                  <Column
                    dataField="updatedBy.full_name"
                    caption="Updated by"
                  />
                  <Column
                    width={50}
                    dataField="status"
                    renderEmpStatus
                    cellRender={({ data }) => renderEmpStatus(data)}
                    caption="Status"
                  ></Column>
                  <Pager
                    visible={true}
                    showPageSizeSelector={false}
                    showNavigationButtons={true}
                    allowedPageSizes={[4, 6, 10]}
                  />
                  <Paging
                    defaultPageIndex={0}
                    defaultPageSize={10}
                    enabled={true}
                  />
                  <Export enabled={true} />
                </DataGrid>
              </div>
            </div>
          )}
        </div>
      </div>
      <EmployeeAddEdit
        show={isEmployeeModal}
        employeeData={employeeData}
        handleClose={() => {
          setIsEmployeeModal(false);
          dispatch(actionEmpList( {status: activeStatus}));
        }}
      />
      <BulkUpload
        show={uploadBulk}
        sampleFileName= {`${SUB_DIRECTORY}/documents/employee data.csv`}
        module="employee"
        dynamic_url="importemployees"
        handleUpdateList={() => {
          setUploadBulk(false);
          dispatch(actionEmpList({ status: activeStatus}));
        }}
      />
    </>
  );
};

export default EmployeeList;
